export type TrackingOptions = {
  component?: string; // Component name
  context?: string; // Context in which the tracking is happening
  page?: string; // Page or section identifier for broader tracking
  prefix?: string; // Prefix (defaults to 'call-intel')
  isDemoAccount?: boolean; // Whether this is for a demo account (adds 'demo' if true)
  abTestGroup?: string; // A/B test group identifier
  customName?: string; // Custom name that overrides other options
};

export const generateTrackingId = ({
  component,
  context,
  page,
  prefix = 'call-intel',
  isDemoAccount = false,
  abTestGroup,
  customName,
}: TrackingOptions): string => {
  if (customName) {
    return [prefix, customName].join('-');
  }

  const baseId = [prefix, page, component].filter(Boolean).join('-');

  const suffixes: string[] = [];

  if (context) {
    suffixes.push(context);
  }

  if (isDemoAccount) {
    suffixes.push('demo');
  }

  if (abTestGroup) {
    suffixes.push(`abTestGroup-${abTestGroup}`);
  }

  return [baseId, ...suffixes].join('-');
};

export const resolveTrackingPlaceholders = (context: string, dynamicValues: Record<string, string>): string => {
  return context.replace(/\${(.*?)}/g, (match, key) => {
    return dynamicValues[key] || match;
  });
};
